var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 37,
    viewBox: "0 0 63 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.546875,
    y: 0.920898,
    width: 62,
    height: 36,
    rx: 18,
    fill: "#000105"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.3041 27.3886H27.7891C26.5441 27.3886 25.5391 26.3836 25.5391 25.1386V13.5586C25.5391 13.3486 25.7041 13.1836 25.9141 13.1836H37.1791C37.3891 13.1836 37.5541 13.3486 37.5541 13.5586V25.1311C37.5541 26.3761 36.5491 27.3811 35.3041 27.3811V27.3886Z",
    fill: "#000105",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4909 12.5208H29.5084C28.9534 12.4949 29.1784 11.6305 29.1334 11.0513C29.1334 10.8093 29.2984 10.6191 29.5084 10.6191H33.4909C33.7009 10.6191 33.8659 10.8093 33.8659 11.0513C33.8209 11.6305 34.0459 12.5036 33.4909 12.5208Z",
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8867 15.6816V24.8916V15.6816Z",
    fill: "#000105"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8867 15.6816V24.8916",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2109 15.6816V24.8916V15.6816Z",
    fill: "#000105"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2109 15.6816V24.8916",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.184 13.7008H24.8115C24.249 13.6783 24.4815 12.9283 24.4365 12.4258C24.4365 12.2158 24.6015 12.0508 24.8115 12.0508H38.184C38.7465 12.0733 38.514 12.8233 38.559 13.3258C38.559 13.5358 38.394 13.7008 38.184 13.7008Z",
    fill: "#000105",
    stroke: "white",
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.05026772b83f6f7d9dc7c644e051d382.svg";
export { ForwardRef as ReactComponent };